import { Fragment } from 'react';

import Switch from 'react-switch';

import { QRCode } from '../../../Components/Form';
import defaultImage from '../Assets/Images/default.png';
import { Fields } from '../Utils/Fields';

const UserFields = ({
  changeIDCardFields,
  addFieldToIDCart,
  fields = null,
}) => {
  const getData = (id, name) => {
    if (fields === null) {
      return '';
    }
    return fields?.find((f) => f.id == id)?.[name];
  };

  return (
    <div
      className='row bg-sky-light shadow-sm rounded-1 mt-1 p-2 py-2 sticky-top'
      style={{ margin: '4px 1px 4px 1px' }}
    >
      <div className='col-12'>
        <div className='d-flex flex-column justify-content-start align-items-start border-bottom pb-3 mb-2 border-dark'>
          <h1 className='text-dark f-13 fornt-weight-bold'>
            فیلد های روی آی دی کارت
          </h1>
        </div>
      </div>
      <div
        className='row mx-0 px-0'
        style={{ maxHeight: '500px', overflow: 'auto' }}
      >
        {Fields.map((field) => (
          <Fragment key={field?.id}>
            {field?.type === 'string' ||
            field?.type === 'date' ||
            field?.type === 'province' ? (
              <div className='col-12 text-center'>
                <div
                  className='rounded p-2 my-2'
                  style={{ background: 'rgb(62 107 122)' }}
                >
                  <div className='d-flex flex-row justify-content-center f-14 font-weight-bold text-white border-bottom border-white my-2 pb-3'>
                    {field?.title}
                  </div>
                  <div className='form-group'>
                    <label className='text-white f-12 text-left'>
                      فاصله از بالا
                    </label>
                    <input
                      className='form-control'
                      type='number'
                      defaultValue={getData(field?.id, 'top')}
                      onChange={(e) =>
                        changeIDCardFields(field?.id, 'top', e.target.value)
                      }
                    />
                  </div>

                  <div className='form-group'>
                    <label className='text-white f-12 text-left'>
                      فاصله از پایین
                    </label>
                    <input
                      defaultValue={getData(field?.id, 'bottom')}
                      className='form-control'
                      type='number'
                      onChange={(e) =>
                        changeIDCardFields(field?.id, 'bottom', e.target.value)
                      }
                    />
                  </div>
                  <div className='form-group'>
                    <label className='text-white f-12 text-left'>
                      فاصله از راست
                    </label>
                    <input
                      defaultValue={getData(field?.id, 'right')}
                      className='form-control'
                      type='number'
                      onChange={(e) =>
                        changeIDCardFields(field?.id, 'right', e.target.value)
                      }
                    />
                  </div>
                  <div className='form-group'>
                    <label className='text-white f-12 text-left'>
                      فاصله از چپ
                    </label>
                    <input
                      defaultValue={getData(field?.id, 'left')}
                      className='form-control'
                      type='number'
                      onChange={(e) =>
                        changeIDCardFields(field?.id, 'left', e.target.value)
                      }
                    />
                  </div>
                  <div className='form-group'>
                    <label className='text-white f-12 text-left d-flex flex-row justify-content-around align-items-center c-pointer'>
                      فونت ضخیم
                      <Switch
                        onChange={(checked) => {
                          changeIDCardFields(field?.id, 'bold', checked);
                        }}
                        defaultChecked={getData(field?.id, 'bold')}
                        checked={getData(field?.id, 'bold')}
                        className='mx-3'
                      />
                    </label>
                  </div>
                  <span
                    onClick={() => addFieldToIDCart(field)}
                    className='w-100 c-pointer btn btn-info text-white f-13'
                  >
                    اضافه کردن
                  </span>
                </div>
              </div>
            ) : field?.type === 'QRCode' ? (
              <div className='col-12'>
                <div
                  className='rounded p-2 my-2'
                  style={{ background: 'rgb(62 107 122)' }}
                >
                  <div className='d-flex flex-row justify-content-center f-14 font-weight-bold text-white border-bottom border-white my-2 pb-3'>
                    {field?.title}
                  </div>
                  <div className='d-flex flex-row justify-content-center my-2'>
                    <QRCode value='/' />
                  </div>

                  <div className='form-group'>
                    <label className='text-white f-12 text-left'>لینک</label>
                    <input
                      defaultValue={getData(field?.id, 'value')}
                      className='form-control'
                      type='text'
                      onChange={(e) =>
                        changeIDCardFields(field?.id, 'value', e.target.value)
                      }
                    />
                  </div>
                  <div className='form-group'>
                    <label className='text-white f-12 text-left'>عرض</label>
                    <input
                      defaultValue={getData(field?.id, 'width')}
                      className='form-control'
                      type='number'
                      onChange={(e) =>
                        changeIDCardFields(field?.id, 'width', e.target.value)
                      }
                    />
                  </div>
                  <div className='form-group'>
                    <label className='text-white f-12 text-left'>ارتفاع</label>
                    <input
                      defaultValue={getData(field?.id, 'height')}
                      className='form-control'
                      type='number'
                      onChange={(e) =>
                        changeIDCardFields(field?.id, 'height', e.target.value)
                      }
                    />
                  </div>
                  <div className='form-group flex flex-row'>
                    <label className='text-white f-12 text-left'>
                      فاصله از بالا
                    </label>
                    <input
                      className='form-control'
                      type='number'
                      defaultValue={getData(field?.id, 'top')}
                      onChange={(e) =>
                        changeIDCardFields(field?.id, 'top', e.target.value)
                      }
                    />
                  </div>
                  <div className='form-group'>
                    <label className='text-white f-12 text-left'>
                      فاصله از پایین
                    </label>
                    <input
                      className='form-control'
                      type='number'
                      defaultValue={getData(field?.id, 'bottom')}
                      onChange={(e) =>
                        changeIDCardFields(field?.id, 'bottom', e.target.value)
                      }
                    />
                  </div>
                  <div className='form-group'>
                    <label className='text-white f-12 text-left'>
                      فاصله از چپ
                    </label>
                    <input
                      className='form-control'
                      type='number'
                      defaultValue={getData(field?.id, 'left')}
                      onChange={(e) =>
                        changeIDCardFields(field?.id, 'left', e.target.value)
                      }
                    />
                  </div>
                  <div className='form-group'>
                    <label className='text-white f-12 text-left'>
                      فاصله از راست
                    </label>
                    <input
                      className='form-control'
                      type='number'
                      defaultValue={getData(field?.id, 'right')}
                      onChange={(e) =>
                        changeIDCardFields(field?.id, 'right', e.target.value)
                      }
                    />
                  </div>
                  <span
                    onClick={() => addFieldToIDCart(field)}
                    className='w-100 c-pointer btn btn-info text-white f-13'
                  >
                    اضافه کردن
                  </span>
                </div>
              </div>
            ) : field?.type === 'image' ? (
              <div className='col-12'>
                <div
                  className='rounded p-2 my-2'
                  style={{ background: 'rgb(62 107 122)' }}
                >
                  <div className='d-flex flex-row justify-content-center f-14 font-weight-bold text-white border-bottom border-white my-2 pb-3'>
                    {field?.title}
                  </div>
                  <div className='d-flex flex-row justify-content-center my-2'>
                    <img src={defaultImage} alt='' width={100} height={100} />
                  </div>
                  <div className='form-group'>
                    <label className='text-white f-12 text-left'>عرض</label>
                    <input
                      className='form-control'
                      type='number'
                      defaultValue={getData(field?.id, 'width')}
                      onChange={(e) =>
                        changeIDCardFields(field?.id, 'width', e.target.value)
                      }
                    />
                  </div>
                  <div className='form-group'>
                    <label className='text-white f-12 text-left'>ارتفاع</label>
                    <input
                      className='form-control'
                      type='number'
                      defaultValue={getData(field?.id, 'height')}
                      onChange={(e) =>
                        changeIDCardFields(field?.id, 'height', e.target.value)
                      }
                    />
                  </div>
                  <div className='form-group'>
                    <label className='text-white f-12 text-left'>
                      فاصله از بالا
                    </label>
                    <input
                      className='form-control'
                      type='number'
                      defaultValue={getData(field?.id, 'top')}
                      onChange={(e) =>
                        changeIDCardFields(field?.id, 'top', e.target.value)
                      }
                    />
                  </div>
                  <div className='form-group'>
                    <label className='text-white f-12 text-left'>
                      فاصله از پایین
                    </label>
                    <input
                      className='form-control'
                      type='number'
                      defaultValue={getData(field?.id, 'bottom')}
                      onChange={(e) =>
                        changeIDCardFields(field?.id, 'bottom', e.target.value)
                      }
                    />
                  </div>
                  <div className='form-group'>
                    <label className='text-white f-12 text-left'>
                      فاصله از چپ
                    </label>
                    <input
                      className='form-control'
                      defaultValue={getData(field?.id, 'left')}
                      type='number'
                      onChange={(e) =>
                        changeIDCardFields(field?.id, 'left', e.target.value)
                      }
                    />
                  </div>
                  <div className='form-group'>
                    <label className='text-white f-12 text-left'>
                      فاصله از راست
                    </label>
                    <input
                      className='form-control'
                      type='number'
                      defaultValue={getData(field?.id, 'right')}
                      onChange={(e) =>
                        changeIDCardFields(field?.id, 'right', e.target.value)
                      }
                    />
                  </div>
                  <span
                    onClick={() => addFieldToIDCart(field)}
                    className='w-100 c-pointer btn btn-info text-white f-13'
                  >
                    اضافه کردن
                  </span>
                </div>
              </div>
            ) : null}
          </Fragment>
        ))}
      </div>
    </div>
  );
};

export default UserFields;
